module.exports = __webpack_public_path__ + "static/assets/e6de357f44755a51246d711589e5669e.svg";